import { render } from "./404.vue?vue&type=template&id=4b97d59a&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=4b97d59a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/jk_107/workspace/Module_Software-HW_Cloud_service_dcloud-dmss-auth-web_L_DMSS-Web_package/code_path/Main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b97d59a"]])

export default __exports__